import { Component } from '@angular/core';
import { Subject, takeWhile } from 'rxjs';
import { Router } from '@angular/router';

import { IPanel, PanelsService } from '@app/core/panels';

@Component({
  selector: 'app-my-panels',
  templateUrl: './my-panels.component.html'
})
export class MyPanelsComponent {
  public records$: Subject<IPanel[]>;
  public selectedPanel: IPanel;
  private destroyed: boolean;

  constructor(private router: Router, private service: PanelsService) {
    this.records$ = new Subject();
    this.loadPanels();
  }

  private loadPanels(): void {
    delete this.selectedPanel;

    this.service
      .getMyPanels()
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((records) => {
        const sortedRecords = records.sort((a, b) => this.compareTitles(a.title, b.title));
        this.records$.next(sortedRecords);
      });
  }

  private compareTitles(a: string = '', b: string = ''): number {
    const cleanA = a.replace(/\*\*/g, '').toLowerCase();
    const cleanB = b.replace(/\*\*/g, '').toLowerCase();
    return cleanA.localeCompare(cleanB);
  }

  public onPanelSelect(): void {
    this.router.navigate(['/my-panels', this.selectedPanel.id]);
  }

  public onRowShow(record: IPanel): void {
    this.router.navigate(['/my-panels', record.id]);
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
